import { render, staticRenderFns } from "./StudyCandidate.vue?vue&type=template&id=3d75e34c&scoped=true&lang=pug"
import script from "./StudyCandidate.vue?vue&type=script&lang=ts"
export * from "./StudyCandidate.vue?vue&type=script&lang=ts"
import style0 from "./StudyCandidate.vue?vue&type=style&index=0&id=3d75e34c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d75e34c",
  null
  
)

export default component.exports